import http from "../base";
import { GET_CHALLENG_PATH, CHALLENGE_BLOKS_APPS } from "../constants/path";
import {
  INS_API_FETCH_CHALLENG,
  INS_API_BLOKS_APPS
} from "../constants/event_consts";
import PresisiteAPIParams from "../persisits/lunch_params";
import { INS_APP_INFO } from "../constants/ins_base_consts";
import { cg_api_signed_body, handleIgHeaders } from "../utils";
import CGAPIBcloksPayload from "../utils/challenge_helper/block_payload";
import { INS_LOGIN_MSG } from "@/api/ins/base/ins_res_const";
import { mobileconfig } from "@/api/ins_api_new/apis/ins_lunch";

export const getChallenge = async (
  challenge: any,
  user_id: string = "",
  not_show_veify: boolean = false
) => {
  const params: Record<string, string> = {};
  params.device_id = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  const challenge_context = challenge && challenge.challenge_context;
  if (challenge_context) {
    params.challenge_context = challenge_context;
  }

  try {
    const result = await http.get(
      GET_CHALLENG_PATH(challenge && challenge.api_path),
      { params },
      { user_id, not_show_veify },
      INS_API_FETCH_CHALLENG
    );
    console.log("getChallenge result ", result);
    return result;
  } catch (error) {
    console.log("getChallenge error", error);
    return Promise.reject(error);
  }
};

export const createBloksAppsBody = async (challenge: any, userId?: string) => {
  const body: Record<string, any> = {};
  console.log("createBloksAppsBody challenge", challenge);
  const {
    nonce_code,
    challenge_context,
    is_bloks_web,
    should_promote_account_status,
    get_challenge,
    security_code,
    user_id
  } = challenge;
  if (get_challenge) {
    body.get_challenge = "true";
  }
  if (!userId) {
    if (nonce_code) {
      body.nonce_code = nonce_code;
    }
    if (security_code) {
      body.security_code = security_code;
    }
    if (is_bloks_web) {
      body.is_bloks_web = is_bloks_web;
    }
    if (typeof should_promote_account_status === "boolean") {
      body.should_promote_account_status = should_promote_account_status
        ? "1"
        : "0";
    }

    if (user_id) {
      body.user_id = String(user_id);
    }
    const cni = challenge.cni;
    if (cni) {
      body.cni = String(cni);
    }
  } else {
    body._uuid = await PresisiteAPIParams.getAPIId("cg_api_device_id");
    body._uid = userId;
  }

  challenge_context && (body.challenge_context = challenge_context);
  return body;
};

export const bloksApps = async (challengeAction: any, userId?: string) => {
  const body = await createBloksAppsBody(challengeAction, userId);

  const mutableBody: any = body;
  if (challengeAction.hasOwnProperty("choice")) {
    // 选择手机号还是邮件验证
    mutableBody.choice = "" + challengeAction.choice;
  }
  mutableBody.bloks_versioning_id = INS_APP_INFO.cg_api_x_bloks_version_id;
  console.log("mutableBody body", mutableBody);
  try {
    const { data, headers } = await http.post(
      CHALLENGE_BLOKS_APPS(challengeAction.bloks_action),
      {
        data: cg_api_signed_body(mutableBody)
      },
      { return_headers: true, user_id: userId },
      INS_API_BLOKS_APPS
    );
    await CGAPIBcloksPayload.init(data);
    const dialog: any = CGAPIBcloksPayload.getDialog();
    console.log("dialog", dialog);
    if (dialog) {
      return Promise.reject({
        error_type: "show_dialog",
        message: { ...dialog }
      });
    }
    const toastData = CGAPIBcloksPayload.getToastData();
    console.log("toastData", toastData);
    if (toastData) {
      return Promise.reject({
        error_type: "show_toast",
        message: toastData
      });
    }
    const userInfo = CGAPIBcloksPayload.getUserInfo();
    if (userInfo) {
      handleIgHeaders(headers, userInfo.pk);
      await mobileconfig(userInfo.pk);
      return {
        status: INS_LOGIN_MSG.INS_LOGIN_SUCCESS,
        logged_in_user: userInfo
      };
    }
    return {};
  } catch (error) {
    return Promise.reject(error);
  }
};
